import { createFileRoute } from "@tanstack/react-router";
import { ModuleDashboard } from "@/features/dashboards/ModuleDashboard";

// Procurement dashboard (PX-PUR-010): features/dashboards.
export const Route = createFileRoute("/_app/procurement/dashboard")({
  component: () => <ModuleDashboard module="procurement" />,
});
